import React, { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import SubscriptionsAPI from 'api/faber/SubscriptionsAPI'
import MUIDataGrid from 'common/AbstractDataGrid/DataGridMUI'
import TextColorFontHeader from 'common/Typography/TextColorFontHeader'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import {
  generateColumnHeader,
  SUB_HISTORY
} from 'helpers/column-generator/generateColumnHeader'
import OrbitSession from 'hooks/useCookies'
import { GetAllFaberUsersDetails } from 'types/api/faber/oneTimePack.type'
import { ICustomerSubHistoryDetails } from 'types/api/faber/subscription.type'

export default function SubHistoryV2() {
  /*FOR DATA GRID */
  const subHistoryColumns = generateColumnHeader(SUB_HISTORY)
  const [page, setPage] = useState(0)
  const faberToken = OrbitSession.get('faberToken')

  const location = useLocation()

  const locationstate = location.state as GetAllFaberUsersDetails
  const customerId = locationstate._id

  //FOR SUBSCRIPTION HISTORY
  const [subRows, setSubRows] = useState<ICustomerSubHistoryDetails[]>([])

  /*API CALL */

  //SUB HISTORY API
  const {
    data: getSubHistory,
    isLoading: getSubHistoryLoading,
    refetch: refetchSubHistory
  } = useQuery(['getSubHistory', faberToken, customerId], async () => {
    const subHistoryResponse =
      await SubscriptionsAPI.getCustomerSubscriptionHistory({
        faberToken: faberToken,
        user_id: customerId
      })
    return subHistoryResponse.data.data
  })

  //FOR FORMATTING SUBSCRIPTION HISTORY FIELDS
  useMemo(() => {
    if (getSubHistory) {
      const subHistoryData = getSubHistory.map(
        ({
          ID,
          CreatedAt,
          UpdatedAt,
          DeletedAt,
          createdBy,
          updatedBy,
          user_id,
          user_email,
          catalog_bundle_id,
          cycle_count,
          status,
          stripe_subscription_id,
          subscription_start_at,
          is_voucher_dispatched,
          paymentType,
          isPaidCurrentCycle,
          isUpgrading,
          dates,
          price,
          currency,
          planName
        }) => ({
          ID,
          CreatedAt,
          UpdatedAt,
          DeletedAt,
          createdBy,
          updatedBy,
          user_id,
          user_email,
          catalog_bundle_id,
          cycle_count,
          status,
          stripe_subscription_id,
          subscription_start_at,
          is_voucher_dispatched,
          paymentType,
          isPaidCurrentCycle,
          isUpgrading,
          dates,
          price,
          currency,
          planName
        })
      )
      setSubRows(subHistoryData)
    }
  }, [getSubHistory, refetchSubHistory])

  useEffect(() => {
    refetchSubHistory()
  }, [])
  return (
    <>
      <TextColorFontHeader>
        Customer&apos;s Subscription History
      </TextColorFontHeader>
      <MUIDataGrid
        loading={getSubHistoryLoading}
        getRowId={(row) => subRows.indexOf(row)}
        columns={subHistoryColumns}
        rows={subRows}
        tableHeight={'300px'}
        rowHeight={52}
        disableColumnFilter
        disableColumnMenu
        disableSelectionOnClick
        pagination
        page={page}
        pageSize={5}
        onPageChange={(newPage) => setPage(newPage)}
        sx={{
          '& .MuiDataGrid-iconSeparator': {
            visibility: 'hidden'
          },
          '& .MuiDataGrid-footerContainer': {
            border: '0'
          },
          '& .MuiDataGrid-cellContent': {
            fontSize: '12px',
            whiteSpace: 'normal !important',
            wordWrap: 'break-word !important'
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontSize: '12px',
            fontWeight: '500'
          },
          '& .MuiDataGrid-cell': {
            border: '0'
          },
          '& .MuiDataGrid-columnHeaders': {
            border: '2',
            borderWidth: '2px',
            borderColor: circlesOrbitColorPalette.neutrals[200]
          },
          '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
          },
          mx: '-10px'
        }}
      />
    </>
  )
}
